import { Faker, base, en } from "@faker-js/faker";
import { delay as _delay, http as mswHttp } from "msw";

export function createFaker(seed: string) {
    const instance = new Faker({ locale: [base, en], seed: hashSeed(seed) });
    instance.setDefaultRefDate(new Date("2026-03-08"));

    return instance;
}

function hashSeed(name: string) {
    let hash = 0;
    for (const ch of name) {
        hash = ((hash << 5) - hash + ch.charCodeAt(0)) | 0;
    }

    return Math.abs(hash);
}

export const options = {
    delay: true
};

const mockDataResets: (() => void)[] = [];

/** Registers how a mock puts the data it keeps in memory back to its start, for `resetMockData`. */
export function onResetMockData(reset: () => void) {
    mockDataResets.push(reset);
}

export function resetMockData() {
    mockDataResets.forEach(reset => reset());
}

export function delay(...args: Parameters<typeof _delay>): Promise<void> {
    if (options.delay) {
        return _delay(...args);
    } else {
        return Promise.resolve();
    }
}

export function paginate<T>(data: T[], page: number, pageSize: number) {
    const currentPage = Math.max(1, page);
    const currentPageSize = Math.max(1, pageSize);

    return {
        data: data.slice((currentPage - 1) * currentPageSize, currentPage * currentPageSize),
        pagination: {
            page: currentPage,
            pageSize: currentPageSize,
            total: data.length
        }
    };
}

// Takes the API origin rather than reading the runtime config: core must not depend on a workspace package.
export function createCorsHandler(apiUrl: string) {
    const origin = new URL(apiUrl).origin;

    return mswHttp.all("*", ({ request }) => {
        if (new URL(request.url).origin !== origin) {
            return;
        }

        if (request.credentials !== "include") {
            throw new TypeError("CORS: credentials must be 'include'");
        }
    });
}
